/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestChatworkSendMessageRequest,
} from '../models/index';
import {
    RequestChatworkSendMessageRequestFromJSON,
    RequestChatworkSendMessageRequestToJSON,
} from '../models/index';

export interface ChatworkSendPostRequest {
    req: RequestChatworkSendMessageRequest;
}

/**
 * 
 */
export class ChatworkApi extends runtime.BaseAPI {

    /**
     * Chatworkへメッセージ送信
     * Chatworkへメッセージ送信
     */
    async chatworkSendPostRaw(requestParameters: ChatworkSendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling chatworkSendPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/chatwork/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestChatworkSendMessageRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Chatworkへメッセージ送信
     * Chatworkへメッセージ送信
     */
    async chatworkSendPost(requestParameters: ChatworkSendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.chatworkSendPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
